import './index.scss';
import React, { useEffect, useRef, useState } from 'react';
import { getBooleanValue } from '../../utils';
import { Checkbox, ListView, NavBar, PullToRefresh, Toast } from 'antd-mobile';
import { allReadDone, list, removeAll, remove } from '../../services/saas/notifyUser';
import moment from 'moment';
import { useHistory } from 'react-router';
import { preRouteUrl } from '../../sysConfig';

const CheckboxItem = Checkbox.CheckboxItem;

function ListWrap(props) {
  return (
    <ul
      className="news-list"
      onTouchStart={props.handleTouchStart}
      onTouchEnd={props.handleTouchEnd}
    >
      {props.children}
    </ul>
  );
}

function NewsNotice() {
  const listRef = useRef();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [draging, setDraging] = useState(false);
  const [hasMore, setHasMore] = useState(false);
  let [pageIndex, setPageIndex] = useState(0);
  const dataS = new ListView.DataSource({
    getRowData: (dataBlob, sectionID, rowID) => {
      return dataBlob[sectionID][rowID];
    },
    rowHasChanged: (row1, row2) => row1 !== row2,
  });
  const [dataSource, setDataSouce] = useState(dataS);

  const history = useHistory();

  const timerRef = useRef({});
  const [operation, setOperation] = useState(false);
  const [checked, setChecked] = useState([]);

  const getNotify = async (page) => {
    await setLoading(true);
    const response = await list({
      size: 6,
      current: page || 1,
    });
    if (response.success && response.data.records) {
      const newsList = (page === 1 ? [] : data).concat(response.data.records);
      setDraging(false);
      setLoading(false);
      setData(newsList);
      setDataSouce(dataSource.cloneWithRows(newsList));
      setHasMore(response.data.current < response.data.pages);
      setPageIndex(page);
    }
  };

  const row = (rowData, sectionID, rowID) => {
    const { id, actionName, isRead, sourceAppName, createTime, content } = rowData;
    let currentDate = moment(moment().format('YYYY-MM-DD 00:00:00')).valueOf();
    let time = '';
    if (moment(createTime).valueOf() >= currentDate) {
      time = moment(createTime).format('HH:mm:ss');
    }
    return (
      <li className="news-list-item" key={rowID}>
        <CheckboxItem
          className={`check ${operation ? 'display' : ''}`}
          key={id}
          onChange={() => {
            if (checked.indexOf(id) < 0) {
              setChecked(checked.concat(id));
            } else {
              setChecked(checked.filter((item) => item !== id));
            }
          }}
          checked={checked.indexOf(id) > -1}
        />
        <div
          className={`item-info ${operation ? 'handle' : ''}`}
          onClick={() => {
            history.push(`${preRouteUrl}/personal/notifyInfo/${id}`);
          }}
        >
          <div className={`${isRead === 0 ? 'status' : ''}`}></div>
          <div className="first-line">
            <div className="title">{actionName}</div>
            <div className="time">{time || createTime}</div>
          </div>
          <div className="info">
            【{sourceAppName}】：{content}
          </div>
        </div>
      </li>
    );
  };

  const onEndReached = function () {
    if (!loading && hasMore) {
      getNotify(++pageIndex);
    }
  };

  useEffect(() => {
    getNotify(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const readDoneAll = async () => {
    const respReadDone = await allReadDone();
    if (respReadDone.success && respReadDone.data) {
      Toast.success('操作成功');
      getNotify(1);
    }
  };

  const deteleAll = async () => {
    const respRemoveAll = await removeAll({ isRead: '' });
    if (respRemoveAll.success && respRemoveAll.data) {
      Toast.success('操作成功');
      getNotify(1);
    }
  };

  const detele = async () => {
    if (checked.length > 0) {
      const respRemove = await remove({ ids: checked.toString() });
      if (respRemove.success && respRemove.data) {
        Toast.success('操作成功');
        getNotify(1);
      }
    } else {
      Toast.info('请选择一条记录');
    }
  };

  const handleTouchStart = () => {
    timerRef.current = setTimeout(() => {
      setOperation(true);
    }, 1000);
  };

  const handleTouchEnd = () => {
    clearTimeout(timerRef.current);
  };

  return (
    <div className={`notifyUser ${getBooleanValue('IS_IMMERSE', false) ? 'immerse' : ''}`}>
      <NavBar
        mode="light"
        icon={<div className="back"></div>}
        onLeftClick={() => window.history.go(-1)}
        rightContent={
          operation
            ? [
                <div
                  onClick={() => {
                    setOperation(false);
                    setChecked([]);
                  }}
                >
                  取消
                </div>,
              ]
            : [
                <div className="readDone" onClick={readDoneAll}>
                  标记已读
                </div>,
                <div className="clear" onClick={deteleAll}>
                  清空
                </div>,
              ]
        }
      >
        <span>消息通知</span>
      </NavBar>
      <div className={`content ${operation ? 'bottom' : ''}`}>
        <ListView
          ref={listRef}
          dataSource={dataSource}
          renderHeader={false}
          renderFooter={() => (
            <div style={{ padding: 10, textAlign: 'center' }}>
              {hasMore ? (hasMore ? '加载中...' : '加载完成') : '没有更多'}
            </div>
          )}
          renderBodyComponent={() => (
            <ListWrap handleTouchStart={handleTouchStart} handleTouchEnd={handleTouchEnd} />
          )}
          renderRow={row}
          className="news-list-warp"
          pageSize={6}
          onScroll={() => {
            console.log('scroll');
          }}
          scrollRenderAheadDistance={500}
          onEndReached={onEndReached}
          onEndReachedThreshold={10}
          pullToRefresh={
            <PullToRefresh
              refreshing={draging}
              onRefresh={() => {
                setDraging(true);
                getNotify(1);
              }}
            />
          }
        />
      </div>
      <div className="footer">
        <div
          className="checkAlll"
          onClick={() => {
            if (checked.length === data.length) {
              setChecked([]);
            } else {
              setChecked(data.map((item) => item.id));
            }
          }}
        >
          全选
        </div>
        <div className="remove" onClick={detele}>
          删除
        </div>
      </div>
    </div>
  );
}

export default NewsNotice;
